/*global karoAjaxObject */
const karoAjaxUrl = JSON.parse(karoAjaxObject.ajax_url);
const karoAjaxNonce = karoAjaxObject.ajax_nonce;


//POST FILTER
//*************
//Filter container
const karoPostFilter = document.getElementById('post-filter');

if(karoPostFilter) {

    //Get query varaibles
    let postType = karoPostFilter.dataset.type;
    let postTax = karoPostFilter.dataset.tax;


    //Get all categories in container
    let categorylist = karoPostFilter.getElementsByTagName('li');

    //Only add addEventListener if we have categories
    if(categorylist.length > 0) {

         //POST data
         let obj = {
            action: 'karopharma_post_filter',
            nonce: karoAjaxNonce,
            post_type: postType,
            post_tax: postTax,
        };

        //addEventListener to container
        karoPostFilter.addEventListener('click', function(event) {

            var target = event.target;

            //Stop fireing on both child & parent
            if ( target.tagName !== 'LI' )
                return;

             //Remove active class
            for (let item of categorylist) {
                item.classList.remove('active');
            }

            //Add active class
            target.classList.add('active');

            //Add clicked term to object
            obj.post_term = target.dataset.term;

            //Convert object to url query string
            let queryString = Object.keys(obj).map(function(key) {
                return key + '=' + encodeURIComponent(obj[key])
            }).join('&');

            //Target container
            const postArchiveContainer = document.querySelector('ul.post-list');

            if(postArchiveContainer) {

                //Creat object
                const xhttp = new XMLHttpRequest();

                //Status
                xhttp.onreadystatechange = function () {

                    //4 = Response from server has been completely loaded.
                    if(this.readyState === 4) {

                        //Remove a loading class on container
                        postArchiveContainer.classList.remove('loading');

                        //http status between 200 to 299 are all successful
                        if (this.status == 200 && this.status < 300) {

                            //Replace list with filtered result
                            postArchiveContainer.innerHTML = this.responseText;
                            
                        //Something whent wrong
                        } else {
                            postArchiveContainer.innerHTML = '<p>Something whent wrong. Please contact us so that we can correct it.</p>';
                        } 

                    //While waiting response from server
                    } else {
                        //Add a loading class on container
                        postArchiveContainer.classList.add('loading');

                        //Add a spinner icon
                        postArchiveContainer.innerHTML = '<div class="spinner"></div>';
                    }
                }

                xhttp.open('POST', karoAjaxUrl, true);
                xhttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                xhttp.send(queryString);

            }

            
        });

    }

}

